/**
 *
 * Asynchronously loads the BrandFilterPopup component
 *
 */

import loadable from 'utils/loadable';

export default loadable(() => import('./index'));
